import * as React from "react";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem } from "@progress/kendo-react-charts";
const AssetPerformance = ({
  assetDetails
}) => {
  console.log('assetDetails1', assetDetails)

  const donutRor = assetDetails.map((item) => ({
    category: item.AlternateName,
    Profit: item.Profit,
    Invested: item.Invested,
  }));
  return <Chart >
      <ChartSeries>
        <ChartSeriesItem type="bar" gap={2} spacing={0.25} data={donutRor}  field="Profit" color= '#1B9C85' name="Profit"  categoryField="category"/>
        <ChartSeriesItem type="bar" gap={2} spacing={0.25} data={donutRor}  field="Invested" color= '#FF8686' name="Invested"  categoryField="category"/>
      </ChartSeries>
      <ChartLegend position={"bottom"} visible={true} />
    </Chart>;

};
export default AssetPerformance;